import { GatsbyImage, StaticImage, getImage } from 'gatsby-plugin-image';
import parser from 'html-react-parser';
import React from 'react';

const MemberInfoModal = ({
  id,
  onClose,
  image,
  name,
  position,
  pronouns,
  linkedinLink,
  facebookLink,
  email,
  description,
}) => {  
  return (
    <div
      className='modal team-modal fade'
      id={id}
      onClick={onClose}
      onKeyDown={e => e.key === 'Escape' && onClose()}
      aria-label='Modal'
      role='button'
      tabIndex={0}
    >
      <div className='modal-dialog team-modal-white-bx'>
        <div className='modal-content'>
          <button
            className='btn-close-icon'
            data-bs-dismiss='modal'
            onClick={onClose}
          >
            <StaticImage src='../../images/close-icon-1.png' alt='close' />
          </button>
          <div className='modal-body'>
            <div className='row'>
              <div className='col-md-4'>
                <div className='team-bio-image white-circle-ptrn-col'>
                  {image && <GatsbyImage image={getImage(image)} alt='image' />}
                </div>
                <div className='team-bio-content'>
                  {name && (
                    <div className='heading-level-2 blue-color mb-0'>
                      {name}
                    </div>
                  )}
                  {position && <p className='position'>{position}</p>}
                  {pronouns && <p className='pronounce'>{pronouns}</p>}

                  <ul className='social-team-icons'>
                    {linkedinLink && (
                      <li>
                        <a href={linkedinLink} target='_blank' rel='noreferrer'>
                          <StaticImage src='../../images/in.png' alt='image' />
                        </a>
                      </li>
                    )}
                    {facebookLink && (
                      <li>
                        <a href={facebookLink} target='_blank' rel='noreferrer'>
                          <StaticImage
                            src='../../images/facebook.png'
                            alt='image'
                          />
                        </a>
                      </li>
                    )}
                    {email && (
                      <li>
                        <a href={`mailto:${email}`}>
                          <StaticImage
                            src='../../images/e-mail.png'
                            alt='image'
                          />
                        </a>
                      </li>
                    )}
                  </ul>
                </div>
              </div>
              <div className='col-md-8'>
                {description && parser(description)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MemberInfoModal;
